// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
let firebaseConfig; 

const APP_ENV = window._env_?.APP_ENV || "prod";

console.log("Firebase environment:", APP_ENV);
if(APP_ENV === "dev") {
  firebaseConfig = {
    apiKey: "AIzaSyDXtqZM2S5D0Of-TkKnwx4c4sn8sRQJSYk",
    authDomain: "giva-dev-26385.firebaseapp.com",
    projectId: "giva-dev-26385",
    storageBucket: "giva-dev-26385.appspot.com",
    messagingSenderId: "203398934118",
    appId: "1:203398934118:web:f05ed5bec3fd2606e287a7",
    measurementId: "G-82E023F1MB"
  };
} else {
  firebaseConfig = {
    apiKey: "AIzaSyBCLBFOzh4Npt5tyzn3d8feV7ElDg2Jwj8",
    authDomain: "giva-276409.firebaseapp.com",
    databaseURL: "https://giva-276409.firebaseio.com",
    projectId: "giva-276409",
    storageBucket: "giva-276409.appspot.com",
    messagingSenderId: "426801055772",
    appId: "1:426801055772:web:6e79021573ae784b8637d9",
    measurementId: "G-HB40PR93QR"
  };
}
// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
